<button [type]="type" mat-flat-button color="primary">
  <ng-content></ng-content>
</button>
